<p-menu #menu [popup]="true" [model]="menuItems()" appendTo="body" />
<button
  pButton
  id="more-actions-button"
  icon="fa-solid fa-ellipsis-vertical"
  [text]="true"
  [rounded]="iconOnly()"
  (click)="menu.toggle($event)"
  [attr.aria-label]="'measurement.actions.more' | translate"
>
  @if (!iconOnly()) {
    {{ 'measurement.actions.more' | translate }}
  }
</button>
